import React from "react";

const ModalRoot: React.FC = () => {
  return <div id="modal-root"></div>;
};

export default ModalRoot;
